module.exports = __webpack_public_path__ + "img/coin-market-cap.4ed5a85.webp";